import { debugLogs } from 'utils/common';

const differceIsHigh = (balls, diff, scoreTriggerAd) => {
  try {
    for (let i = 0; i < diff; i += 1) {
      const element = balls[i];
      if (!element) {
        return false;
      }
      debugLogs(
        `$$$$ Run-${element.runs} | over-${element.over} | ballNo-${
          element.number
        }`,
      );
      if (element && scoreTriggerAd.includes(element.runs)) {
        return true;
      }
    }
    return false;
  } catch (error) {
    debugLogs(error);
    return false;
  }
};
const destroyAndReexecuteAd = regex => {
  try {
    if (window?.googletag && regex) {
      const aadsArray = window.googletag.pubads().getSlots();
      const aadsArr = aadsArray.filter(e => e.getAdUnitPath().match(regex));
      const divid = aadsArr[0].getSlotElementId();
      debugLogs(`$$$$ destroy call started`);
      if (aadsArr.length) {
        debugLogs(`$$$$ found arr destroy call`, aadsArr);
        window.googletag.pubads().clear(aadsArr);
        window.googletag.destroySlots(aadsArr);
        if (window._toi_processedSlots && window._toi_processedSlots.length) {
          window._toi_processedSlots = window._toi_processedSlots.filter(
            li => li !== divid,
          );
          debugLogs(`$$$$ removed from destroy call _toi_processedSlots`);
        }
        if (window._toi_displayedSlots && window._toi_displayedSlots.length) {
          window._toi_displayedSlots = window._toi_displayedSlots.filter(
            li => li !== divid,
          );
          debugLogs(`$$$$ removed from destroy call _toi_displayedSlots`);
        }
        if (window?._dfpObj?._til_processedSlots?.length) {
          window._dfpObj._til_processedSlots = window._dfpObj._til_processedSlots.filter(
            li => li !== divid,
          );
          debugLogs(`$$$$ removed from destroy call _til_processedSlots`);
        }
      }
    }
  } catch (error) {
    debugLogs(error);
  }
};

const displayScorecardAd = (callback, adTimeout = 10, adobj) => {
  try {
    const { adCode, size, divId } = adobj;
    const innovRegex = new RegExp(adCode, 'gi');
    const AD_OBJ = {
      adType: 'dfp',
      deviceType: '',
    };
    callback(AD_OBJ);
    if (window?._dfpObj?._til_processedSlots?.length) {
      window._dfpObj._til_processedSlots = window._dfpObj._til_processedSlots.filter(
        li => li !== divId,
      );
      debugLogs(`$$$$ removed from destroy call _til_processedSlots`);
    }
    document.getElementById(divId).innerHTML = '';
    window.displayAllAdsInArray([
      {
        adCode,
        divId,
        size,
        clearDiv: 1,
      },
    ]);
    setTimeout(() => {
      debugLogs(`$$$$ remove ad from gpt & processed `);
      destroyAndReexecuteAd(innovRegex);
      callback(null);
    }, adTimeout * 1000);
  } catch (error) {
    debugLogs(error);
  }
};

const cricketWidgetAd = (scorecard, widgetad, callback) => {
  try {
    if (
      typeof window !== 'undefined' &&
      scorecard &&
      scorecard?.matchStatus === 'Play In Progress' &&
      scorecard?.innings?.length
    ) {
      debugLogs(`$$$$ Jarvis caimpaign is active`);
      const curentInn = scorecard.innings.length - 1;
      const currentInning = scorecard.innings[curentInn];
      if (!currentInning) {
        debugLogs(`$$$$ Wrong inning Found`);
        return;
      }
      const { balls, number } = currentInning.ballByBall[0];
      const { runs, number: ballNo } = balls[0];
      const alreadyDisplayAd = `${curentInn}_${number}_${ballNo}`;
      if (typeof window !== 'undefined' && !window.alreadyDisplayAd) {
        window.alreadyDisplayAd = '';
      }
      if (
        typeof window !== 'undefined' &&
        alreadyDisplayAd !== window.alreadyDisplayAd
      ) {
        const lastBallNo = window.alreadyDisplayAd.split('_')[2];
        const lastOver = window.alreadyDisplayAd.split('_')[1];
        window.alreadyDisplayAd = alreadyDisplayAd;
        debugLogs(
          `$$$$ Run-${runs} | over-${number} | ballNo${ballNo} | finalid-${alreadyDisplayAd} | lastBallNo_${lastBallNo}`,
        );
        const diff = lastBallNo ? ballNo - lastBallNo : 0;
        const overdiff = lastOver ? number - lastOver : 0;
        debugLogs(`$$$$ diff - ${diff}  | overdiff - ${overdiff}`);
        let call = false;
        const { scoreTriggerAd, adTimeout } = widgetad;
        if (scoreTriggerAd.includes(runs)) {
          call = true;
        } else if (overdiff > 0) {
          const lastballs = currentInning.ballByBall[1].balls;
          const findInd = lastballs.findIndex(l => lastBallNo === l.number);
          call = differceIsHigh(lastballs, findInd, scoreTriggerAd);
          if (!call) {
            call = differceIsHigh(balls, ballNo + 1, scoreTriggerAd);
          }
        } else if (diff > 1) {
          call = differceIsHigh(balls, diff, scoreTriggerAd);
        }
        if (call) {
          debugLogs(`$$$$ it a four or one | call ad`);
          displayScorecardAd(callback, adTimeout, widgetad);
        }
      } else {
        debugLogs(`$$$$ alreadyDisplayAd Same Last ball`, alreadyDisplayAd);
      }
    } else {
      debugLogs(
        `$$$$ match is not Active but caimpaign is active  | widgetad - `,
        widgetad,
      );
    }
  } catch (error) {
    debugLogs(error);
  }
};

export { cricketWidgetAd, displayScorecardAd };
